export enum ActionTypes {
    UPAY_APP_ID = 'UPAY_APP_ID',
    UPAY_APP_RESET = 'UPAY_APP_RESET',
    UPAY_ADMIN = 'UPAY_ADMIN',
    UPAYQR_APP = 'UPAYQR_APP',
    UPAYQR_ADMIN = 'UPAYQR_ADMIN',
}
